import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Formik, Form, Field } from 'formik'

import { t } from '../translation/index'
import * as yup from 'yup'
import AuthErrorBox from 'components/Auth/AuthErrorBox'

import { changePassword, resetAuthError, authFail } from 'store/actions'
import { authSuccess } from '../store/actions/authActions'
//Musiccare$1
class MyAccount extends Component {
  state = {
    scaleClassIsSet: false,
    showPasswords: false,
    clicked: false,
  }

  componentDidMount() {
    document.documentElement.classList.add('no_scale_mod')
    this.setState({ scaleClassIsSet: true })
  }

  render() {
    const accessSchema = yup.object().shape({
      currentPassword: yup
        .string()
        .required('PASSWORD_IS_REQUIRED')
        .min(6, 'PASSWORD_IS_TOO_SHORT')
        .max(256, 'PASSWORD_IS_TOO_LONG')
        .matches(
          /^.*(?=.{6,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
          'PASSWORD_MUST_CONTAIN'
        ),
      newPassword: yup
        .string()
        .required('NEW_PASSWORD_IS_REQUIRED')
        .min(6, 'NEW_PASSWORD_IS_TOO_SHORT')
        .max(256, 'NEW_PASSWORD_IS_TOO_LONG')
        .matches(
          /^.*(?=.{6,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
          'PASSWORD_MUST_CONTAIN'
        ),
      newPasswordConfirm: yup
        .string()
        .required('CONFIRM_PASSWORD_IS_REQUIRED')
        .oneOf([yup.ref('newPassword')], 'PASSWORDS_DO_NOT_MATCH'),
    })

    return (
      <div className="modal_content modal_open">
        <div className="popup acc_mod save_files_mod">
          <div className="popup_in offset_mod">
            <h2 className="section_title v5_mod offset_mod">
              {t('settings.VIEW_ACCOUNT')}
            </h2>
            <div className="account_block">
              <Link
                to="/my-account"
                className="close_btn right_pos_mod account_mod account_mod"
              ></Link>
              <div className="account_title">{`${t('settings.NEW_PASS')}`}</div>
              <Formik
                initialValues={{
                  currentPassword: '',
                  newPassword: '',
                  newPasswordConfirm: '',
                }}
                onSubmit={async (
                  { currentPassword, newPassword },
                  { setSubmitting, resetForm }
                ) => {
                  const { success, message } = await this.props.changePassword(
                    currentPassword,
                    newPassword
                  )

                  if (success) {
                    this.setState({ success: true })
                    resetForm()
                    setSubmitting(false)
                    return authSuccess(t(success))
                  }

                  this.setState({ success: false })
                  authFail(t(message))
                  setSubmitting(false)
                }}
                validationSchema={accessSchema}
              >
                {({ submitForm, isSubmitting, errors, touched, handleChange }) => (
                  <Form className="account_form">
                    {!this.state.success && (errors || this.state.clicked) ? (
                      <AuthErrorBox
                        formFields={[
                          'newPassword',
                          'newPasswordConfirm',
                          'currentPassword',
                        ]}
                        formTouched={touched}
                        formErrors={errors}
                        apiResponseError={this.props?.authError || ''}
                        resetApiResponseError={resetAuthError}
                      />
                    ) : null}
                    <div
                      className="account_form_controller"
                      style={{ paddingTop: '1vh' }}
                    >
                      <Field
                        className={`form_field v5_mod ${
                          this.state.clicked || touched.currentPassword ? 'error' : ''
                        }`}
                        type="password"
                        name="currentPassword"
                        id="currentPassword"
                        label={t('CURRENT_PASSWORD')}
                        placeholder={`${t('settings.OLD_PASS')}`}
                        disabled={isSubmitting || this.state.success}
                        variant="outlined"
                        onChange={(e) => (resetAuthError(), handleChange(e))}
                      />
                    </div>
                    <div className="account_form_controller">
                      <Field
                        className={`form_field v5_mod ${
                          this.state.clicked || touched.currentPassword ? 'error' : ''
                        }`}
                        type={this.state.showPasswords ? 'text' : 'password'}
                        name="newPassword"
                        id="newPassword"
                        label={t('NEW_PASSWORD')}
                        placeholder={`${t('settings.NEW_PASS')}`}
                        disabled={isSubmitting || this.state.success}
                        variant="outlined"
                        autoComplete="off"
                        onChange={(e) => (resetAuthError(), handleChange(e))}
                      />
                    </div>
                    <div className="account_form_controller">
                      <Field
                        className={`form_field v5_mod ${
                          this.state.clicked || touched.currentPassword ? 'error' : ''
                        }`}
                        type={this.state.showPasswords ? 'text' : 'password'}
                        name="newPasswordConfirm"
                        id="newPasswordConfirm"
                        label={t('NEW_PASSWORD_CONFIRM')}
                        placeholder={`${t('signup.PASSWORD_CONFIRM')}`}
                        disabled={isSubmitting || this.state.success}
                        variant="outlined"
                        autoComplete="off"
                        onChange={(e) => (resetAuthError(), handleChange(e))}
                      />
                    </div>
                    <div className="account_form_controller">
                      <button
                        className="btn_v2"
                        onClick={() => {
                          this.setState({ clicked: true })
                          submitForm()
                        }}
                      >
                        {t('settings.CHANGE_PASSWORD')}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth: { attributes, error } }) => ({
  attributes,
  authError: error,
})

const willMapDispatchToProps = {
  resetAuthError,
  changePassword,
}

export default connect(mapStateToProps, willMapDispatchToProps)(MyAccount)
